import React, { useEffect, useState } from "react";
import "../../css/main.css";
import MainCarousel from "./MainCarousel";
import { headerText } from "../../App";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
// import { toast } from "wc-toast";
import axios from "axios";
import config from "../../config";
import MobildIntro from "./MobildIntro";
import ModalAppDownload from "../../componant/modal/ModalAppDownload";
import { isMobile } from "react-device-detect";
import NoticePopup,  { MobileNoticePopup } from "./NoticePopup";

export default function NumberOneMain() {
  const [headerTextAtom, setHeaderTextAtom] = useAtom(headerText);
  const [priceData, setPriceData] = useState([]);
  const [width, setWidth] = React.useState(window.innerWidth);

  const [showModal, setShowModal] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [mobile, setMobile] = useState("");
  const [showNoticePopup, setShowNoticePopup] = useState(false);
  const [showMobileNoticePopup, setShowMobileNoticePopup] = useState(false);
  
  const navigate = useNavigate();

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    setHeaderTextAtom("");
  }, []);

  function goReg(url) {
    if (localStorage.getItem("access_token")) {
      navigate(url, { state: { main: 1 } });
      return;
    }
    // return toast.error("로그인 후 이용가능 합니다.", {
    //   duration: 500,
    // });
    navigate("/login");
  }

  const callTodayMain = async () => {
    axios({
      url: config.API_URL + "/comm/selMvalue",
      method: "post",
      data: {},
      headers: {
        ...axios.defaults.headers,
        Authorization: "",
      },
    }).then((res) => {
      const data = res?.data?.resultList;
      // const temp = data[3];
      // for (let i = 3; i > 0; i--) {
      //   data[i] = data[i - 1];
      // }
      // data[0] = temp;
      setPriceData(data);
    });
  };

  const checkPopupShow = () => {
    // localStorage.removeItem('hideToday');  // 초기화
    const storedDate = localStorage.getItem('hideToday');
    const today = new Date().toISOString().split('T')[0];
    if (!storedDate || storedDate !== today) {
      width <= 512 ? setShowMobileNoticePopup(true) : setShowNoticePopup(true)
    } else {
      width <= 512 ? setShowMobileNoticePopup(false) : setShowNoticePopup(false)
    }
  }

  useEffect(() => {
    callTodayMain();
    checkPopupShow();
    // 백그라운드에 있다가 화면 다시 보일 때 체크    
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkPopupShow();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // 앱이 아닌 모바일에서 앱다운로드 유도 팝업창 띄우기
  useEffect(() => {
    // localStorage.removeItem('hideAppDownloadModal');  // 초기화
    const isApp = isInAppWebView();
    const hide = localStorage.getItem("hideAppDownloadModal");
    if (isMobile && !isApp && hide !== "true") {
      setShowModal(true);
    }
  }, [isMobile]);

  const handleClose = () => {
    if (dontShowAgain) {
      localStorage.setItem("hideAppDownloadModal", "true");
    }
    setShowModal(false);
  };

  const isInAppWebView = () => {
    const ua = navigator.userAgent;

    const isModerniPad =
      navigator.userAgent.includes("Macintosh") && "ontouchend" in document;

    const isIOS = /iPhone|iPod|iPad/.test(ua) || isModerniPad;

    const isIOSWebView =
      (/iPhone|iPod|iPad/.test(ua) || isModerniPad) &&
      !/Safari/.test(ua) &&
      /AppleWebKit/.test(ua);

    const isAndroidWebView =
      (/Android/.test(ua) && /wv/.test(ua)) ||
      /\bVersion\/[\d.]+.*Chrome\/\d/.test(ua);

    const isIOSMobileWeb = isIOS && !isIOSWebView;
    setMobile(isIOSMobileWeb ? "Ios" : "Android");

    // const isCustomApp = ua.includes('MyAppName'); // 앱에서 유저 에이전트 수정 시
    // return isIOSWebView || isAndroidWebView || isCustomApp;
    return isIOSWebView || isAndroidWebView;
  };

  // return width <= 768 ? (   512  430
  return width <= 512 ? (
    <>
      <MobildIntro priceData={priceData} />
      {/* 모바일 알림 팝업창 */}
      {/* <MobileNoticePopup
        show={showMobileNoticePopup}
        onHide={() => setShowMobileNoticePopup(false)}
      /> */}
      <ModalAppDownload
        mobile={mobile}
        show={showModal}
        dontShowAgain={dontShowAgain}
        setDontShowAgain={setDontShowAgain}
        onHide={handleClose}
      />
    </>
  ) : (
    <>
      <MainCarousel />
      {/* PC 알림 팝업창 */}
      {/* {showNoticePopup && <NoticePopup onClose={() => setShowNoticePopup(false)} />} */}

      <section>
        <div className="section1_wrapper">
          <div className="container container-outer-section1">
            <div className="card card-banner">
              <div className="card-body">
                <h1>거래 시세</h1>
                 <ul>
                  {priceData?.length > 0 &&
                    priceData?.map((item, index) => {
                      if ( item?.car_weight_cd === 2303 || item?.car_weight_cd === 2304 ) return;
                      return (
                        <li key={index}>
                          <label>
                            {/* {item?.deal_category_cd === 2101 && "개인"} */}
                            {/* {item?.deal_category_cd === 2102 && "법인매매"}
                              {item?.deal_category_cd === 2103 && "법인임대"} */}
                            {item?.deal_category_cd === 2101 && item?.car_weight_cd === 2301 && "개인용달"}
                            {item?.deal_category_cd === 2101 && item?.car_weight_cd === 2302 && "개인개별"}
                            {item?.deal_category_cd === 2104 && "주선면허"}
                            {/* {item?.car_weight_cd === 2303 && "개인대형"} */}
                            {/* {item?.car_weight_cd === 2304 && "전기차 소형"} */}
                          </label>
                          <span
                            className={`${
                              (item?.deal_category_cd === 2101 &&
                                item?.car_weight_cd === 2301 &&
                                "lbl-orange") ||
                              (item?.deal_category_cd === 2101 &&
                                item?.car_weight_cd === 2302 &&
                                "lbl-green") ||
                              // (item?.deal_category_cd === 2101 &&
                              //   item?.car_weight_cd === 2303 &&
                              //   "lbl-blue") ||
                              // (item?.deal_category_cd === 2101 &&
                              //   item?.car_weight_cd === 2304 &&
                              //   "lbl-red") ||
                              (item?.deal_category_cd === 2104 && "lbl-purple")
                            } amount`}
                          >
                            {item?.avg_price
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </span>
                          <span className="unit">만원</span>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
          {/* 고객센터 추가 */}
          <div className="container container-section1">
            {/* <div className="support-center">
              <div className="phone-box">
                <div className="phone-box1">
                  <img
                    src={"/img/icon_phone_bk.svg"}
                    alt=""
                    style={{ width: "45px", height: "45px" }}
                  />
                </div>
                <div className="phone-box2">
                  <span className="phone-text">
                    고객센터
                    <span className="center-time">(평일 09:00~18:00)</span>
                  </span>
                  <span className="phone">010·4478·8944</span>
                </div>
              </div>
            </div> */}
            <div className="row gx-5 pt-2">
              <div className="col gy-3">
                {/* <h2 className="blue">팝니다</h2> */}
                <div className="card card-section1">
                  <div className="card-body">
                    <div className="blue-container container-1 pe-5x">
                      <div>
                        <h3>판매 중인 매물</h3>
                        <a style={{ textDecoration: "none" }} href={"/selling"}>
                          {/* <img
                            src={process.env.PUBLIC_URL + "/img/btn_sell.png"}
                            alt=""
                            style={{position:'relative'}}
                          /> */}
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <img
                              src={process.env.PUBLIC_URL + "/img/btn_sell.png"}
                              alt=""
                              style={{ display: "block" }}
                            />
                            <span
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                width: "150px",
                                fontSize: "16px",
                                color: "#4f7dc8",
                                transform: "translate(-31%, -50%)",
                                letterSpacing: "-0.9px",
                                fontWeight: "bold",
                                pointerEvents: "none", // 클릭 방해하지 않도록
                              }}
                            >
                              매물정보 확인하기
                            </span>
                          </div>
                        </a>
                      </div>
                      <div>
                        {/* <img
                          src={
                            process.env.PUBLIC_URL + "/img/section1-banner1.png"
                          }
                          alt=""
                        /> */}
                      </div>
                    </div>
                    <a
                      style={{ textDecoration: "none", cursor: "pointer" }}
                      onClick={() => goReg("/selling-request")}
                    >
                      <div className="blue-container2 container-2">
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/img/section1-icon1.png"
                            }
                            alt=""
                          />
                        </div>
                        <div>
                          <h4>
                            팔고 싶은 <span>&nbsp;매물등록</span>
                          </h4>
                          {/* <a
                            style={{ textDecoration: "none" }}
                            onClick={() => goReg("/selling-request")}
                          >
                            팝니다 등록하기
                          </a> */}
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col gy-3">
                {/* <h2 className="red">삽니다</h2> */}
                <div className="card card-section1">
                  <div className="card-body">
                    <div className="red-container container-1">
                      <div>
                        <h3>사고 싶은 매물</h3>
                        <a style={{ textDecoration: "none" }} href={"/buying"}>
                          {/* <img
                            src={process.env.PUBLIC_URL + "/img/btn_buy.png"}
                            alt=""
                          /> */}
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <img
                              src={process.env.PUBLIC_URL + "/img/btn_buy.png"}
                              alt=""
                              style={{ display: "block" }}
                            />
                            <span
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                width: "150px",
                                fontSize: "16px",
                                color: "#ff5b02",
                                transform: "translate(-31%, -50%)",
                                letterSpacing: "-0.9px",
                                fontWeight: "bold",
                                pointerEvents: "none", // 클릭 방해하지 않도록
                              }}
                            >
                              매물정보 확인하기
                            </span>
                          </div>
                        </a>
                      </div>
                      <div>
                        {/* <img
                          src={
                            process.env.PUBLIC_URL + "/img/section1-banner2.png"
                          }
                          alt=""
                        /> */}
                      </div>
                    </div>
                    <a
                      style={{ textDecoration: "none", cursor: "pointer" }}
                      onClick={() => goReg("/buying-register")}
                    >
                      <div className="red-container2 container-2">
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/img/section1-icon2.png"
                            }
                            alt=""
                          />
                        </div>
                        <div>
                          <h4>
                            사고 싶은 <span>&nbsp;매물등록</span>
                          </h4>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="section2_wrapper">
          <div className="container container-section2">
            <h2 className="section2_heading">
              ‘탑탑’과 함께하면 안심할 수 있어요
            </h2>
            <p className="section2_caption">
              직접 만나서 확인하지 않아도 모든 거래를 안전하게 대행해 드립니다
            </p>

            <div className="row sec2-row">
              <div className="col">
                <div className="card card-sec2">
                  <div className="card-body">
                    <img
                      src={process.env.PUBLIC_URL + "/img/sec2-img1.png"}
                      alt=""
                    />
                    <h4 className="sec2-card-heading">
                      실명인증을 통한
                      <br />
                      고객관리
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card card-sec2">
                  <div className="card-body">
                    <img
                      className="img2"
                      src={process.env.PUBLIC_URL + "/img/sec2-img2.png"}
                      alt=""
                    />
                    <h4 className="sec2-card-heading">
                      양수양도를 위한
                      <br />
                      꼼꼼한 서류검증
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card card-sec2">
                  <div className="card-body">
                    <img
                      className="img3"
                      src={process.env.PUBLIC_URL + "/img/sec2-img3.png"}
                      alt=""
                    />
                    <h4 className="sec2-card-heading pt-1">
                      블록체인 기반의
                      <br />
                      보안 서비스
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card card-sec2">
                  <div className="card-body">
                    <img
                      className="img4"
                      src={process.env.PUBLIC_URL + "/img/sec2-img4.png"}
                      alt=""
                    />
                    <h4 className="sec2-card-heading last">
                      탑탑에서<br />
                      실시간 진행상황 확인
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-90px pb-sm-0">
        <div className="section3_wrapper">
          <div className="container container-section3">
            <h2 className="section3_heading">왜? ‘탑탑’을 찾을까요?</h2>

            <img
              className="section3_mainbanner"
              src={process.env.PUBLIC_URL + "/img/section3_mainbanner.png"}
              alt=""
            />
          </div>
        </div>
      </section>
      <ModalAppDownload
        mobile={mobile}
        show={showModal}
        dontShowAgain={dontShowAgain}
        setDontShowAgain={setDontShowAgain}
        onHide={handleClose}
      />
    </>
  );
}
